import { render, staticRenderFns } from "./phoneFrame.vue?vue&type=template&id=f7cf709a&scoped=true"
import script from "./phoneFrame.vue?vue&type=script&lang=js"
export * from "./phoneFrame.vue?vue&type=script&lang=js"
import style0 from "./phoneFrame.vue?vue&type=style&index=0&id=f7cf709a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7cf709a",
  null
  
)

export default component.exports